
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { Box, Breadcrumbs, Button, Container, Grid, Link, Paper, Typography } from "@mui/material";

import { NavBar } from "./NavBar";

import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import TrackChangesIcon from '@mui/icons-material/TrackChanges';

import { RootState } from "../store";

import { DialogTurno } from "../dialogs/DialogTurno";

import { setReducerTurno } from "../store/slices/TurnoSlice";
import { asignarUbicacion } from "../store/slices/UbicacionSlice";

import { ConsultarConfiguracion } from "../connections/comun/TurnosConnection";

import { BreadcrumbsProps } from "../interfaces/ui/BreadcrumbsInterface";
import { defaultTurno } from "../interfaces/turnos/TurnoInterface";

interface Props {
    children?: React.ReactNode;
    breadcrumbs?: BreadcrumbsProps[],
    backgroundPaper?: boolean;
    optionTurno?:           boolean;
}

export const Layout = ( { children, breadcrumbs, backgroundPaper = true, optionTurno = false } : Props ) => {

    const dispatch = useDispatch();

    const { sistemaTurnos } = useSelector( ( state: RootState ) => state.auth );
    const { turno, loadingTurno } = useSelector( ( state: RootState ) => state.turno );

    const [openTurno, setOpenTurno] = useState( false );

    useEffect(() => {
    
        async function obtener(){

            dispatch( setReducerTurno( { turno: defaultTurno, loadingTurno: true, } ) );     

            await ConsultarConfiguracion({ usuario_id: sistemaTurnos }).then( resp => {

                const { success, data } = resp;

                if( success ){    

                    setTimeout(() => {                    
    
                        const { ultimo_turno, ubicacion } = data;              
                                    
                        dispatch( setReducerTurno( { turno: ultimo_turno ?? defaultTurno, loadingTurno: false, } ) );        
                        dispatch( asignarUbicacion( { ubicacion: ubicacion } ) );  
                        
                        
                    }, 700);
                }
                else {
                    dispatch( setReducerTurno( { turno: defaultTurno, loadingTurno: false, } ) );   
                }
                
            });
        }    
        
        if( optionTurno && sistemaTurnos ){
            obtener();              
        }

    }, [ dispatch, optionTurno, sistemaTurnos ])   

    useEffect(() => {
      
        if( turno.turno_estado.id === 7 ){
            setOpenTurno( true );
        }

    }, [ turno ])    
    
    return (

        <>        
            <NavBar />            

            <Container maxWidth='xl' sx={{ mt: 15, pb: 5 }}>

                <Grid container>

                    <Grid size={{ md: optionTurno ? 10 : 12, xs: optionTurno ? 10 : 12 }}>

                    {
                        breadcrumbs?.length !== 0
                        &&
                            <Breadcrumbs aria-label="breadcrumb" separator={ <ArrowForwardIosOutlinedIcon style={{ marginBottom: 2, fontSize: 16 }} /> }>
                            
                                <HomeOutlinedIcon style={{ fontSize: 24, marginTop: 3 }} />

                                {
                                    breadcrumbs?.map( ( { text, link }, index ) => (

                                        ( index === breadcrumbs.length - 1 )
                                        ?
                                            link
                                            ?
                                                <Link key={ index } href={ link } sx={{ textDecoration: 'none' }}>
                                                    <Typography variant="subtitle2" color="secondary" fontSize={20} fontWeight={'600'}>
                                                        { text }
                                                    </Typography>
                                                </Link>
                                            :
                                                <Typography key={ index } variant="subtitle2" color="secondary" fontSize={20} fontWeight={'600'}>
                                                    { text }
                                                </Typography>
                                        :

                                            link
                                            ?
                                                <Link key={ index } href={ link } sx={{ textDecoration: 'none' }}>
                                                    <Typography variant="subtitle2" color="secondary" fontSize={16}>
                                                        { text }
                                                    </Typography>
                                                </Link>
                                            :
                                                <Typography key={ index } variant="subtitle2" color="secondary" fontSize={16}>
                                                    { text }
                                                </Typography>                                       
                                    ))
                                }

                            </Breadcrumbs>
                    }

                    </Grid>
                    
                    {
                        optionTurno
                        &&
                            <Grid size={{ md: 2, xs: 2 }}>

                                <Button        
                                    fullWidth                     
                                    variant="contained"
                                    startIcon={ <TrackChangesIcon /> }
                                    color={ turno.turno_numero !== 0 ? 'success' : 'primary' }
                                    loading={ loadingTurno }
                                    onClick={ () => setOpenTurno( true ) }
                                >                            
                                    Turno { turno.turno_numero !== 0 ? turno.turno_numero : '' }
                                </Button>

                            </Grid>
                    }

                </Grid>

                <Box component={ backgroundPaper ? Paper : 'div' } sx={{ mt: 2, p: backgroundPaper ? 3 : 0 }}>

                    { children }

                </Box>
               
            </Container>

            <DialogTurno 
                openDialog={ openTurno }
                handleCloseDialog={ () => setOpenTurno( false ) }
            />
        
        </>      
       
    )
}